import { render, staticRenderFns } from "./default_2.vue?vue&type=template&id=85bf990e&scoped=true"
import script from "./default_2.vue?vue&type=script&lang=js"
export * from "./default_2.vue?vue&type=script&lang=js"
import style0 from "./default_2.vue?vue&type=style&index=0&id=85bf990e&prod&lang=scss"
import style1 from "./default_2.vue?vue&type=style&index=1&id=85bf990e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bf990e",
  null
  
)

export default component.exports